import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { Observable } from 'rxjs/Observable';
import { JobConstants } from '../../common/utils/job-constants';

@Injectable()
export class JobsNotifierService {

    private static completedJobsSubject: Subject<any> = new Subject<any>();
    private static runningJobsSubject: Subject<any> = new Subject<any>();
    private static runningJobsCountSubject: Subject<any> = new Subject<any>();
    private static refreshActivityLogEventSubject: Subject<any> = new Subject<any>();
    private static serviceToSubjectMap: Map<String, Subject<any>> = new Map<String, Subject<any>>();
    private static serviceToCountMap: Map<string, number> = new Map<string, number>();
    private static serviceToCompletedJobsMap: Map<String, Array<Object>> = new Map<String, Array<Object>>();


    setJobs(jobs: any): void {
        let runningJobs = [];
        let completedJobs = [];

        jobs.forEach((job) => {
            if ( job.hasOwnProperty('isDone') && job.isDone === true ) {
                if ( job.hasOwnProperty('jobType') && JobsNotifierService.serviceToSubjectMap.has(job.jobType) ) {
                    this.addJobToServiceComplpetedJobList(job);
                }
                completedJobs.push(job);
            } else {
                runningJobs.push(job);
            }
        });
        JobsNotifierService.serviceToSubjectMap.forEach((value: Subject<any>, key: String) => {
            if ( JobsNotifierService.serviceToCompletedJobsMap.has(key) ) {
                value.next(JobsNotifierService.serviceToCompletedJobsMap.get(key));
            }
        });

        if ( completedJobs.length !== 0 ) {
            JobsNotifierService.completedJobsSubject.next(completedJobs);
        }
        if ( runningJobs.length !== 0 ) {
            JobsNotifierService.runningJobsSubject.next(runningJobs);
        }
        JobsNotifierService.serviceToCompletedJobsMap.clear();
    }

    addJobToServiceComplpetedJobList(job) {
        if ( JobsNotifierService.serviceToCompletedJobsMap.has(job.jobType) ) {
            JobsNotifierService.serviceToCompletedJobsMap.get(job.jobType).push(job);
        } else {
            let filteredJob = new Array<Object>();
            filteredJob.push(job);
            JobsNotifierService.serviceToCompletedJobsMap.set(job.jobType, filteredJob);
        }
    }

    getCompletedJobs(service: string = 'all'): Observable<any> {
        if ( service === 'all' ) {
            return JobsNotifierService.completedJobsSubject.asObservable();
        } else if ( JobConstants.JOB_TYPES.hasOwnProperty(service) ) {
            if ( JobsNotifierService.serviceToSubjectMap.has(service) ) {
                JobsNotifierService.serviceToCountMap.set(service, JobsNotifierService.serviceToCountMap.get(service) + 1);
                return JobsNotifierService.serviceToSubjectMap.get(service).asObservable();
            } else {
                return this.subscribeToNewService(service);
            }
        }
    }

    getRunningJobs(): Observable<any> {
        return JobsNotifierService.runningJobsSubject.asObservable();
    }

    setRunningJobsCount(count) {
        JobsNotifierService.runningJobsCountSubject.next(count);
    }

    getRunningJobsCount(): Observable<any> {
        return JobsNotifierService.runningJobsCountSubject.asObservable();
    }

    setRefreshActivityLogEvent() {
        JobsNotifierService.refreshActivityLogEventSubject.next();
    }

    getRefreshActivityLogEvent() {
        return JobsNotifierService.refreshActivityLogEventSubject.asObservable();
    }

    subscribeToNewService(service: string) {
        JobsNotifierService.serviceToSubjectMap.set(service, new Subject<any>());
        JobsNotifierService.serviceToCountMap.set(service, 1);
        return JobsNotifierService.serviceToSubjectMap.get(service);
    }

    unsubscribeService(service: string) {
        if ( service === 'all' ) {
            return;
        }
        if ( JobsNotifierService.serviceToCountMap.get(service) === 1 ) {
            JobsNotifierService.serviceToCountMap.delete(service);
            JobsNotifierService.serviceToSubjectMap.delete(service);
        } else {
            JobsNotifierService.serviceToCountMap.set(service, JobsNotifierService.serviceToCountMap.get(service) - 1);
        }
    }


}



// WEBPACK FOOTER //
// ./src/app/services/job-notifier.service.ts